import type { ReactNode } from "react";
import {
  I18nProvider as FoundationI18nProvider,
  useT as useFoundationT,
  type Locale,
} from "@csa/web-foundation";
import { dictionaries, type MessageKey } from "./dictionaries";

// The console's i18n composition: feed the merged dictionary (base chrome +
// console surfaces) into the foundation machinery, and expose a `useT` typed over
// the console's full key set so a missing surface key is a compile error. Surfaces
// keep importing `useT`/`I18nProvider` from `../i18n` — no path churn.
export function I18nProvider({
  children,
  initial = "tr",
}: {
  children: ReactNode;
  initial?: Locale;
}) {
  return (
    <FoundationI18nProvider dictionaries={dictionaries} initial={initial}>
      {children}
    </FoundationI18nProvider>
  );
}

export function useT() {
  return useFoundationT<MessageKey>();
}

export type { Locale };
